import * as React from 'react';
import { loadScript, useDynamicData } from '@avensia/excite';
import { styled } from '@glitz/react';

const WIDGET_CONTAINER_ID = 'ingrid-pdp-widget';

declare global {
  interface Window {
    _ingridPDPWidgetApi: {
      render: (id: string, config: NordicNest.Api.IngridProductPageConfigApiModel) => void;
      addListener: (event: string, listener: CallableFunction) => void;
      onItemAdded: (sku: string) => void;
    };
  }
}

export default function IngridPdpWidget(props: NordicNest.Api.IngridProductPageConfigApiModel) {
  const [bootstrapLoaded, setBootstrapLoaded] = React.useState(false);
  const divRef = React.useRef<HTMLDivElement>(null);
  const [cart] = useDynamicData<Excite.Commercetools.CartApiModel>();
  const [scriptSettings] = useDynamicData<NordicNest.Api.ScriptSettingsApiModel>();

  React.useEffect(() => {
    if (scriptSettings?.ingridPdpWidgetScriptUrl) {
      if (!window._ingridPDPWidgetApi) {
        loadScript(scriptSettings.ingridPdpWidgetScriptUrl, {
          async: true,
          attributes: { type: 'module', crossorigin: 'anonymous ' },
        }).then(() => {
          setBootstrapLoaded(true);
        });
      } else {
        setBootstrapLoaded(true);
      }
    }
  }, [scriptSettings?.ingridPdpWidgetScriptUrl]);

  React.useEffect(() => {
    if (bootstrapLoaded && cart?.id) {
      renderWidget(props, divRef, cart.id);
    }
  }, [bootstrapLoaded, cart?.id, props]);

  return bootstrapLoaded ? <div ref={divRef} id={WIDGET_CONTAINER_ID}></div> : <IngridPdpWidgetPlaceholder />;
}

async function renderWidget(
  ingridConfig: NordicNest.Api.IngridProductPageConfigApiModel,
  divRef: React.RefObject<HTMLDivElement | null>,
  cartId: string,
) {
  if (ingridConfig.cart) {
    const config = ingridConfig;

    // Add cart id to the config-object since it is not populated in the NordicNest.Api.IngridProductPageConfigApiModel to save on performance.
    config.cart.cart_id = cartId;

    if (divRef.current) divRef.current.innerHTML = '';
    window._ingridPDPWidgetApi.render(WIDGET_CONTAINER_ID, config);
  }
}

const IngridPdpWidgetPlaceholder = styled.div({
  minHeight: 93,
});
